import { LoginForm } from './loginForm';
import '../../../styles/login.css';

const AdminLogin = () => {
  return (
    <div className="login-container">
      <LoginForm />
    </div>
  );
};

export default AdminLogin;
